export const myMixinDateTimestamp = {
    methods: {
        dateToTimestamp(dateString) {
            if (dateString === null || dateString === undefined || !dateString) {
                return
            }
            // Разбиваем строку даты на компоненты
            const [day, month, year] = dateString.split(".");

            // Создаём объект Date (учитываем, что месяц в JavaScript начинается с 0)
            const date = new Date(year, month - 1, day);

            // Возвращаем таймштамп
            return (date.getTime() / 1000);
        },
        timestampToDate(timestamp, format) {
            if (timestamp === null || timestamp === undefined || !timestamp) {
                return
            }
            // Создаём объект Date на основе таймштампа
            const date = new Date(timestamp * 1000);
            if (format === 'YYYY') {
                return date.getFullYear();
            }
            if (format === 'd.m.y') {
                // Извлекаем компоненты даты
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0"); // Месяц начинается с 0
                const year = date.getFullYear();

                // Формируем строку в формате дд.мм.гггг
                return `${day}.${month}.${year}`;
            }
        }
    }
}

export const myNameUser = {
    methods: {
        getShortFullName(user, format = false) {

            if (user.i === null || user.i === undefined || !user.i) {
                return
            }
            if (format) {
                if (format === "fam i.o.") {
                    const fam = user.f; // Фамилия
                    const imInitial = user.i.charAt(0) + "."; // Первая буква имени
                    const otInitial = user.o.charAt(0) + "."; // Первая буква отчества

                    return `${fam} ${imInitial}${otInitial}`; // Формируем Фамилия И.О.
                }
                if (format === "fam i.") {
                    const fam = user.f; // Фамилия
                    const imInitial = user.i.charAt(0) + "."; // Первая буква имени

                    return `${fam} ${imInitial}`; // Формируем Фамилия И.
                }
            } else {
                return `${user.f} ${user.i} ${user.o}`
            }


        },
    }
}